import styled from '@app/styled';

export const ClientName = styled.span`
    margin-left: 16px;
    font-size: 15px;
    line-height: 21px;
`;

export const ClientIcon = styled.img`
    width: 32px;
    height: 32px;
`;
